import React, { useContext } from 'react'
import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/miranda-react/dist/tokens'

import { Container } from 'core/ui/Container'

import { BID_STATUS } from 'legacy/constants/bids'
import { LoadBoardContext } from 'legacy/contexts/loadBoard'

import { BidAwardedNotification } from './BidAwardedNotification'
import { BidOfferAcceptedNotification } from './BidOfferAcceptedNotification'
import { BidOfferTimedOutNotification } from './BidOfferTimedOutNotification'
import { BidRefusedNotification } from './BidRefusedNotification'
import { BidRemovedNotification } from './BidRemovedNotification'

const NotificationsWrapper = styled(Container)`
  position: fixed;
  top: calc(var(--navbar-height) + ${getToken('spacing-8')});
  left: 0;
  right: 0;
  padding: 0 ${getToken('spacing-4')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: ${getToken('spacing-4')};
  transition: transform 200ms;
  z-index: 20;
`

const bidStatusToComponentMap = {
  [BID_STATUS.AWARDED]: BidAwardedNotification,
  [BID_STATUS.ACCEPTED]: BidOfferAcceptedNotification,
  [BID_STATUS.REFUSED]: BidRefusedNotification,
  [BID_STATUS.REMOVED]: BidRemovedNotification,
  [BID_STATUS.TIMED_OUT]: BidOfferTimedOutNotification,
}

function Notifications() {
  const [{ bids, bookingOffer }] = useContext(LoadBoardContext)
  const bidNotifications = Object.values(bids).map(bid => {
    const { load, status } = bid

    if (bookingOffer?.id === load.uuid) {
      return null
    }

    if (status in bidStatusToComponentMap) {
      const BidNotificationComponent = bidStatusToComponentMap[status]
      return <BidNotificationComponent key={bid.uuid} bid={bid} />
    }
    return <React.Fragment key={bid.uuid} />
  })

  return <NotificationsWrapper>{bidNotifications}</NotificationsWrapper>
}

export { Notifications }
